export const GA_MEASUREMENT_ID =
  process.env.REACT_APP_GA_MEASUREMENT_ID || process.env.REACT_APP_GOOGLE_ANALYTICS_ID;

export const initGA = () => {
  if (!GA_MEASUREMENT_ID || typeof window === 'undefined') return;

  if (!window.gtag) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];

    function gtag() {
      window.dataLayer.push(arguments);
    }

    window.gtag = gtag;

    gtag('js', new Date());
    gtag('config', GA_MEASUREMENT_ID);
  }
};

// Automatically attempt initialization when window is available
if (typeof window !== 'undefined' && GA_MEASUREMENT_ID) {
  initGA();
}

export const pageView = path => {
  if (typeof window === 'undefined') return;
  initGA();
  if (window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: path,
    });
  }
};

export const trackEvent = (name, params = {}) => {
  if (process.env.NODE_ENV === 'development') {
    console.log('[GA4 Event]:', name, params);
  }
  if (typeof window === 'undefined') return;
  initGA();
  if (window.gtag) {
    window.gtag('event', name, params);
  }
};

export const event = trackEvent;
